import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import News from '../components/News';
import Seo from '../components/Seo';

const NewsPage = () => (
  <Layout pageTitle='Dimon | News'>
    <Seo Sitetitle='Blog' />
    <PageHeader title='Blog' mainTitle='blog' path='blog' />
    <News />
  </Layout>
);

export default NewsPage;
